const ids = new WeakMap();
let last = 0;

export function elementId(element) {
  if (!ids.has(element)) {
    ids.set(element, String(++last));
  }
  return ids.get(element);
}
